import React, { useState } from 'react';
import { useData } from '../../store/DataContext';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Search, UserPlus, Users, User } from 'lucide-react';
export const Customers: React.FC = () => {
  const {
    patients,
    walkInClients,
    addWalkInClient,
    logBillingAudit
  } = useData();
  const [activeTab, setActiveTab] = useState<'registered' | 'walkin'>('registered');
  const [searchQuery, setSearchQuery] = useState('');
  const [showAddWalkIn, setShowAddWalkIn] = useState(false);
  const [walkInForm, setWalkInForm] = useState({
    name: '',
    phone: '',
    nrcPassport: '',
    email: '',
    address: ''
  });
  const filteredPatients = patients.filter(p => p.firstName.toLowerCase().includes(searchQuery.toLowerCase()) || p.lastName.toLowerCase().includes(searchQuery.toLowerCase()) || p.bmcFileNumber.toLowerCase().includes(searchQuery.toLowerCase()) || p.contact.includes(searchQuery));
  const filteredWalkIns = walkInClients.filter(c => c.name.toLowerCase().includes(searchQuery.toLowerCase()) || c.phone && c.phone.includes(searchQuery) || c.nrcPassport && c.nrcPassport.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleAddWalkIn = (e: React.FormEvent) => {
    e.preventDefault();
    const newClient = addWalkInClient(walkInForm);
    logBillingAudit('Create Walk-in Client', `Created walk-in client ${newClient.name}`);
    setShowAddWalkIn(false);
    setWalkInForm({
      name: '',
      phone: '',
      nrcPassport: '',
      email: '',
      address: ''
    });
    setActiveTab('walkin');
  };
  return <div className="space-y-6" data-id="element-1084">
      <div className="flex justify-between items-center" data-id="element-1085">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1086">Customers</h1>
        <Button onClick={() => setShowAddWalkIn(true)} data-id="element-1087">
          <UserPlus className="w-4 h-4 mr-2" data-id="element-1088" /> New Walk-in Client
        </Button>
      </div>

      <Card noPadding data-id="element-1089">
        <div className="border-b border-gray-200" data-id="element-1090">
          <nav className="flex -mb-px" data-id="element-1091">
            <button onClick={() => setActiveTab('registered')} className={`w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm ${activeTab === 'registered' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1092">
              <Users className="w-5 h-5 inline-block mr-2" data-id="element-1093" />
              Registered Patients ({patients.length})
            </button>
            <button onClick={() => setActiveTab('walkin')} className={`w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm ${activeTab === 'walkin' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1094">
              <User className="w-5 h-5 inline-block mr-2" data-id="element-1095" />
              Walk-in Clients ({walkInClients.length})
            </button>
          </nav>
        </div>

        <div className="p-4 border-b border-gray-200 bg-gray-50" data-id="element-1096">
          <div className="relative max-w-md" data-id="element-1097">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1098">
              <Search className="h-5 w-5 text-gray-400" data-id="element-1099" />
            </div>
            <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Search customers..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1100" />
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-1101">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-1102">
            <thead className="bg-gray-50" data-id="element-1103">
              <tr data-id="element-1104">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1105">
                  {activeTab === 'registered' ? 'BMC Number' : 'Client ID'}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1106">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1107">
                  Contact
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1108">
                  {activeTab === 'registered' ? 'Age/Sex' : 'NRC/Passport'}
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1109">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1110">
              {activeTab === 'registered' ? filteredPatients.length > 0 ? filteredPatients.map(patient => <tr key={patient.id} className="hover:bg-gray-50" data-id="element-1111">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600" data-id="element-1112">
                        {patient.bmcFileNumber}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1113">
                        {patient.firstName} {patient.lastName}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1114">
                        {patient.contact}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1115">
                        {patient.age} / {patient.sex}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1116">
                        <Button variant="outline" size="sm" data-id="element-1117">
                          Create Invoice
                        </Button>
                      </td>
                    </tr>) : <tr data-id="element-1118">
                    <td colSpan={5} className="px-6 py-12 text-center text-gray-500" data-id="element-1119">
                      No registered patients found.
                    </td>
                  </tr> : filteredWalkIns.length > 0 ? filteredWalkIns.map(client => <tr key={client.id} className="hover:bg-gray-50" data-id="element-1120">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-500" data-id="element-1121">
                      {client.id.split('-')[1]}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1122">
                      {client.name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1123">
                      {client.phone || '—'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1124">
                      {client.nrcPassport || '—'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1125">
                      <Button variant="outline" size="sm" data-id="element-1126">
                        Create Invoice
                      </Button>
                    </td>
                  </tr>) : <tr data-id="element-1127">
                  <td colSpan={5} className="px-6 py-12 text-center text-gray-500" data-id="element-1128">
                    No walk-in clients found.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Add Walk-in Client Modal */}
      {showAddWalkIn && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-1129">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6" data-id="element-1130">
            <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-1131">
              New Walk-in Client
            </h3>
            <form onSubmit={handleAddWalkIn} className="space-y-4" data-id="element-1132">
              <Input label="Full Name" required value={walkInForm.name} onChange={e => setWalkInForm({
            ...walkInForm,
            name: e.target.value
          })} data-id="element-1133" />
              <Input label="Phone Number (Optional)" value={walkInForm.phone} onChange={e => setWalkInForm({
            ...walkInForm,
            phone: e.target.value
          })} data-id="element-1134" />
              <Input label="NRC/Passport (Optional)" value={walkInForm.nrcPassport} onChange={e => setWalkInForm({
            ...walkInForm,
            nrcPassport: e.target.value
          })} data-id="element-1135" />
              <Input label="Email (Optional)" type="email" value={walkInForm.email} onChange={e => setWalkInForm({
            ...walkInForm,
            email: e.target.value
          })} data-id="element-1136" />
              <Input label="Address (Optional)" value={walkInForm.address} onChange={e => setWalkInForm({
            ...walkInForm,
            address: e.target.value
          })} data-id="element-1137" />
              <div className="flex justify-end space-x-3 mt-6" data-id="element-1138">
                <Button variant="outline" type="button" onClick={() => setShowAddWalkIn(false)} data-id="element-1139">
                  Cancel
                </Button>
                <Button type="submit" data-id="element-1140">Save Client</Button>
              </div>
            </form>
          </div>
        </div>}
    </div>;
};